/** @jsx jsx */
import { isFunction } from 'lodash';
import { css, jsx } from '@emotion/core';
import { Colors } from '@zapier/design-system';

type Props = {
  isEditing?: boolean;
  renderAside?: () => JSX.Element | null;
  renderLabel?: () => JSX.Element | null;
};

const containerCss = (props: Props) => {
  return {
    border: `1px solid ${props.isEditing ? Colors.ocean : Colors.gray40}`,
    borderRadius: 10,
    padding: 15,
    position: 'relative' as const,
  };
};

const headerCss = css`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto;
  min-height: 40px;
`;
const headerLabelCss = {
  display: 'flex',
  alignItems: 'center',
  '> *': {
    marginRight: 20,
  },
};
const sectionCss = {
  marginTop: 20,
};

const PaymentMethod: React.FC<Props> = props => (
  <section css={containerCss(props)}>
    <header css={headerCss}>
      <div css={headerLabelCss}>
        {isFunction(props.renderLabel) && props.renderLabel()}
      </div>
      {isFunction(props.renderAside) && props.renderAside()}
    </header>
    {props.isEditing && props.children && (
      <div css={sectionCss}>{props.children}</div>
    )}
  </section>
);

export default PaymentMethod;
